var _rect, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 524,
    viewBox: "0 0 383 524",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 383,
    height: 524,
    fill: "#FEB546",
    fillOpacity: 0.47
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_173)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 124.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 139.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 154.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 169.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 184.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 199.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 214.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 229.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 244.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 259.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 124.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 139.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 154.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 169.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 184.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 199.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 214.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 229.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 244.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 259.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 124.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 139.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 154.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 169.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 184.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 199.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 214.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 229.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 244.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 259.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 124.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 139.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 154.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 169.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 184.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 199.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 214.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 229.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 244.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 259.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 124.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 139.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 154.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 169.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 184.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 199.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 214.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 229.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 244.793,
    r: 5,
    fill: "#040744"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 259.793,
    r: 5,
    fill: "#040744"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 274.793,
    r: 5,
    fill: "#040744"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 289.793,
    r: 5,
    fill: "#040744"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 304.793,
    r: 5,
    fill: "#040744"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 319.793,
    r: 5,
    fill: "#040744"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 334.793,
    r: 5,
    fill: "#040744"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 349.793,
    r: 5,
    fill: "#040744"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 364.793,
    r: 5,
    fill: "#040744"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 379.793,
    r: 5,
    fill: "#040744"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 394.793,
    r: 5,
    fill: "#040744"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 409.793,
    r: 5,
    fill: "#040744"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 274.793,
    r: 5,
    fill: "#040744"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 289.793,
    r: 5,
    fill: "#040744"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 304.793,
    r: 5,
    fill: "#040744"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 319.793,
    r: 5,
    fill: "#040744"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 334.793,
    r: 5,
    fill: "#040744"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 349.793,
    r: 5,
    fill: "#040744"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 364.793,
    r: 5,
    fill: "#040744"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 379.793,
    r: 5,
    fill: "#040744"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 394.793,
    r: 5,
    fill: "#040744"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 409.793,
    r: 5,
    fill: "#040744"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 274.793,
    r: 5,
    fill: "#040744"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 289.793,
    r: 5,
    fill: "#040744"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 304.793,
    r: 5,
    fill: "#040744"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 319.793,
    r: 5,
    fill: "#040744"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 334.793,
    r: 5,
    fill: "#040744"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 349.793,
    r: 5,
    fill: "#040744"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 364.793,
    r: 5,
    fill: "#040744"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 379.793,
    r: 5,
    fill: "#040744"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 394.793,
    r: 5,
    fill: "#040744"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 409.793,
    r: 5,
    fill: "#040744"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 274.793,
    r: 5,
    fill: "#040744"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 289.793,
    r: 5,
    fill: "#040744"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 304.793,
    r: 5,
    fill: "#040744"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 319.793,
    r: 5,
    fill: "#040744"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 334.793,
    r: 5,
    fill: "#040744"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 349.793,
    r: 5,
    fill: "#040744"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 364.793,
    r: 5,
    fill: "#040744"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 379.793,
    r: 5,
    fill: "#040744"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 394.793,
    r: 5,
    fill: "#040744"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 409.793,
    r: 5,
    fill: "#040744"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 274.793,
    r: 5,
    fill: "#040744"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 289.793,
    r: 5,
    fill: "#040744"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 304.793,
    r: 5,
    fill: "#040744"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 319.793,
    r: 5,
    fill: "#040744"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 334.793,
    r: 5,
    fill: "#040744"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 349.793,
    r: 5,
    fill: "#040744"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 364.793,
    r: 5,
    fill: "#040744"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 379.793,
    r: 5,
    fill: "#040744"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 394.793,
    r: 5,
    fill: "#040744"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 377,
    cy: 409.793,
    r: 5,
    fill: "#040744"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 145,
    fill: "white",
    transform: "translate(312 119.793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSide);
export default __webpack_public_path__ + "static/media/side.8ef60c1967391fcb119a7ebf8b47afe0.svg";
export { ForwardRef as ReactComponent };